const Footer = () => {
  return (
    <div style={{textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '1.5rem'}}>
        <div style={{fontWeight: '600', color: '#A7A9B3', marginRight: '0.5rem'}}>Powered by</div>
        <img alt="bunny-logo" style={{height: '24px'}} src="https://d8ia9pq8hp3tl.cloudfront.net/img/widget-footer-logo.png"/>
    </div>
  )
}

export default Footer